import HttpHandler from "@/utils/httpHandler";

export default class SignInApi {
    constructor() {
        this.http = new HttpHandler();
    }

    // 签到计时
    signInCount (params) {
        let url = '/api-user/sign_in_time';
        return this.http.post(url, params);
    }

    // 获取签到状态
    getSignInState (params) {
        let url = '/api-user/sign_in_verify';
        return this.http.get(url, params);
    }

    // 签到
    toSignIn (params) {
        let url = '/api-user/sign_in';
        return this.http.post(url, params);
    }

    // 签到记录
    signInRecord (params) {
        let url = '/api-user/sign_in_record';
        return this.http.get(url, params);
    }

    // 获取货币列表
    getCoinList (params) {
        let url = '/api-user/get_coin_list';
        return this.http.get(url, params);
    }
}